var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:{
    [_vm.customClass]: true,
    [_vm.iconOpen]: !_vm.toggleWith,
    [_vm.iconClose]: _vm.toggleWith,
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }